import { Slot } from "radix-ui";
import { type ComponentProps, type ReactNode, useContext } from "react";

import { cn } from "@/shared/lib";

import { Tooltip, TooltipContent, TooltipTrigger } from "../tooltip";
import { SidebarDrawerContext } from "./SidebarDrawerContext";
import {
  type SidebarMenuButtonVariantProps,
  sidebarMenuButtonVariants,
} from "./sidebarMenuButtonVariants";
import { useSidebar } from "./useSidebar";

type SidebarMenuButtonProps = ComponentProps<"button"> &
  SidebarMenuButtonVariantProps & {
    asChild?: boolean;
    isActive?: boolean;
    // Подсказка у значка, когда меню свёрнуто и подписей не видно.
    tooltip?: ReactNode;
  };

export const SidebarMenuButton = ({
  asChild = false,
  isActive,
  tooltip,
  size,
  className,
  ...props
}: SidebarMenuButtonProps) => {
  const inDrawer = useContext(SidebarDrawerContext);
  const { state } = useSidebar();
  const Component = asChild ? Slot.Root : "button";
  const button = (
    <Component
      data-slot="sidebar-menu-button"
      data-active={isActive}
      className={cn(sidebarMenuButtonVariants({ size }), className)}
      {...props}
    />
  );
  if (tooltip === undefined) {
    return button;
  }
  return (
    <Tooltip>
      <TooltipTrigger asChild>{button}</TooltipTrigger>
      <TooltipContent side="right" align="center" hidden={state !== "collapsed" || inDrawer}>
        {tooltip}
      </TooltipContent>
    </Tooltip>
  );
};
